module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", " ", _vm._h('div', {
    staticClass: "main-page news-list",
    staticStyle: {
      "padding-bottom": "60px"
    }
  }, [_vm._h('div', [_vm._h('ul', {
    staticClass: "list-group-item primary"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('router-link', {
    staticClass: "group-link clearfix",
    attrs: {
      "to": {
        path: '/user/center/NewsList/1'
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left img-wrap small"
  }, [_vm._h('img', {
    attrs: {
      "src": require("../../assets/images/icon-sys-message.png")
    }
  })]), " ", _vm._h('span', {
    staticClass: "group-txt"
  }, [_vm._h('span', {
    staticClass: "block overhide clearfix"
  }, [_vm._h('cite', {
    staticClass: "pull-left font-16"
  }, ["系统消息"]), " ", (_vm.pushSummary.systemPush && _vm.pushSummary.systemPush.pushDate) ? _vm._h('cite', {
    staticClass: "pull-right font-12 gray"
  }, [_vm._s(_vm._f("dateDiff")(_vm.pushSummary.systemPush.pushDate))]) : _vm._e()]), " ", (_vm.pushSummary.systemPush && _vm.pushSummary.systemPush.pushContent) ? _vm._h('cite', {
    staticClass: "con font-12"
  }, [_vm._s(_vm.pushSummary.systemPush && _vm.pushSummary.systemPush.pushContent)]) : _vm._h('cite', {
    staticClass: "con font-12"
  }, ["暂无消息"]), " "]), " ", (_vm.pushSummary.systemPushNum > 0) ? _vm._h('i') : _vm._e()])]), " ", _vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('router-link', {
    staticClass: "group-link clearfix",
    attrs: {
      "to": {
        path: '/user/center/NewsList/2'
      }
    }
  }, [_vm._h('span', {
    staticClass: "pull-left img-wrap small"
  }, [_vm._h('img', {
    attrs: {
      "src": require("../../assets/images/icon-inva-message.png")
    }
  })]), " ", _vm._h('span', {
    staticClass: "group-txt"
  }, [_vm._h('span', {
    staticClass: "block overhide clearfix"
  }, [_vm._h('cite', {
    staticClass: "pull-left font-16"
  }, ["邀请消息"]), " ", (_vm.pushSummary.invitePush && _vm.pushSummary.invitePush.pushDate) ? _vm._h('cite', {
    staticClass: "pull-right font-12 gray"
  }, [_vm._s(_vm._f("dateDiff")(_vm.pushSummary.invitePush.pushDate))]) : _vm._e()]), " ", (_vm.pushSummary.invitePush && _vm.pushSummary.invitePush.pushContent) ? _vm._h('cite', {
    staticClass: "con font-12"
  }, [_vm._s(_vm.pushSummary.invitePush && _vm.pushSummary.invitePush.pushContent)]) : _vm._h('cite', {
    staticClass: "con font-12"
  }, ["暂无消息"]), " "]), " ", (_vm.pushSummary.invitePushNum > 0) ? _vm._h('i') : _vm._e()])])])])]), " ", " ", _vm._h('div', {
    staticClass: "navbar"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('ul', {
    staticClass: "clearfix text-center"
  }, [_vm._h('li', [_vm._h('router-link', {
    staticClass: "img-home",
    attrs: {
      "to": {
        path: '/index'
      }
    }
  }, [_vm._h('span', ["管理"])])]), " ", (_vm.isVisitor) ? [_vm._m(1), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "icon-add icon",
    attrs: {
      "to": {
        path: '/quickadd'
      }
    }
  }, ["添加"])]), " ", _vm._h('li', [_vm._h('a', {
    staticClass: "img-contact",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showCurche($event)
      }
    }
  }, [_vm._h('span', ["联系人"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "img-user",
    attrs: {
      "to": {
        path: '/user/center'
      }
    }
  }, [_vm._h('span', ["我的"])])])] : [_vm._h('li', [_vm._h('a', {
    staticClass: "img-xiaoxi active",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._h('span', ["消息"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "icon-add icon",
    attrs: {
      "to": {
        path: '/quickadd'
      }
    }
  }, ["添加"])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "img-contact",
    attrs: {
      "to": {
        path: '/contact/list'
      }
    }
  }, [_vm._h('span', ["联系人"])])]), " ", _vm._h('li', [_vm._h('router-link', {
    staticClass: "img-user",
    attrs: {
      "to": {
        path: '/user/center'
      }
    }
  }, [_vm._h('span', ["我的"])])])], " "])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('h1', ["消息"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
},function (){var _vm=this;
  return _vm._h('li', [_vm._h('a', {
    staticClass: "img-xiaoxi",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._h('span', ["消息"])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-5f4be042!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/user/NewsClass.vue
// module id = 207
// module chunks = 1